import { initializeApp, getApps } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyDluMXfv9vqn68uznMw5h_841WxZ_BzEiE",
  authDomain: "erweb-bucket.firebaseapp.com",
  projectId: "erweb-bucket",
  storageBucket: "erweb-bucket.firebasestorage.app",
  messagingSenderId: "471368522135",
  appId: "1:471368522135:web:cd6924f8403ad699afccd2"
};


// Avoid double-initializing during hot reload
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

// Core SDKs
export const storage = getStorage(app);
export const auth = getAuth(app);

// ✅ A small “authReady” promise you can await before uploading
let _resolveAuth;
export const authReady = new Promise((resolve) => (_resolveAuth = resolve));

onAuthStateChanged(auth, (user) => {
  if (user) {
    console.log("✅ Signed in (anon) uid:", user.uid);
    _resolveAuth(user);
  }
});

// Kick off anonymous sign-in (silently)
signInAnonymously(auth).catch((e) => {
  console.error("Anonymous sign-in failed:", e);
});